import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gumroad = defineConnector({
  identifier: "gumroad",
  name: "Gumroad",
  tagLine: "Digital product sales",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.gumroad\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Gumroad app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Gumroad OAuth Applications](https://app.gumroad.com/oauth/applications) and create a new application to get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/gumroad/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Gumroad account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Gumroad account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://gumroad.com/oauth/authorize",
    tokenEndpoint: () => "https://api.gumroad.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gumroad.com/v2/user",
  },
});
